module.exports = __webpack_public_path__ + "img/expand-sidebar.83add769.svg";